import BranchParcelOrder from 'components/pages/dashboard/parcelOrderForBranch/BranchParcelOrder';
import routes from 'global/Constants/routes';

import { lazy } from 'react';

// const OrderPlacePage = lazy(() => import('../../pages/dashboard/orderPlace/OrderPlacePage'));
// const OrderAddressPage = lazy(() => import('../../pages/dashboard/submitOrder/SubmitOrderPage'));

const ParcelOrder = lazy(() => import('../../pages/dashboard/ParcelOrder/ParcelOrder'));
const OrderList = lazy(() => import('../../pages/dashboard/ParcelOrder/List/components/OrderList'));
const ParcelList = lazy(() => import('../../pages/dashboard/ParcelOrder/List/components/ParcelList'));

// const ParcelOrderDetail = lazy(() => import('../../pages/dashboard/ParcelOrder/detail/ParcelOrderDetail'));
const ParcelOrderCompleteDetail = lazy(() => import('../../pages/dashboard/ParcelOrder/detail/ParcelCompleteDetail'));
const OmParcelDetail = lazy(() => import('../../pages/dashboard/ParcelOrder/parcelsWithSameContractCodes/parcelsWithSameContractCodes'));
const UnPaidOrders = lazy(() => import('../../pages/dashboard/ParcelOrder/unpaidOrders/UnpaidOrders'));
const OrderDetail = lazy(() => import('../../pages/dashboard/ParcelOrder/detail/OrderDetail'));
const PreOrderDetail = lazy(() => import('../../pages/dashboard/ParcelOrder/preOrder/PreOrderDetail'));
const CreateOrdersByExcel = lazy(() => import('../../pages/dashboard/BulkOrderingByExcel/BulkOrderingByExcel'));
const OrderWaitingSendToJet = lazy(() => import('../../pages/dashboard/ParcelOrder/orderWaitingSendToJet/OrderWaitingSendToJet'));
// const AdvancedOrderRegistration = lazy(() => import('../../pages/dashboard/AdvancedOrderRegistration/AdvancedOrderRegistration'));
const CreateOrderResult = lazy(() => import('../../pages/dashboard/ParcelOrder/components/CreateOrderResult'));
const CustomerPromotionList = lazy(() => import('../../pages/dashboard/promotion/CustomerPromotionList'));
const QueueOrderList = lazy(() => import('../../pages/dashboard/queueOrder/QueueOrderList'));

export const orderPlaceRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  // {
  //   path: routes.orderWaitingSendToJet.path,
  //   component: AdvancedOrderRegistration,
  //   isPrivate: routes.orderWaitingSendToJet.isPrivate,
  //   accessRole: hasAccessLevel(10),
  // },
  { path: routes.customerPromotion.path, component: CustomerPromotionList, isPrivate: routes.customerPromotion.isPrivate, accessRole: hasAccessLevel(10) },
  {
    path: routes.queueOrderList.path,
    component: QueueOrderList,
    isPrivate: routes.queueOrderList.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.createOrderResult.path,
    component: CreateOrderResult,
    isPrivate: routes.createOrderResult.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderWaitingSendToJet.path,
    component: OrderWaitingSendToJet,
    isPrivate: routes.orderWaitingSendToJet.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.bulkOrderingByExcel.path,
    component: CreateOrdersByExcel,
    isPrivate: routes.bulkOrderingByExcel.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.preOrderDetail.path,
    component: PreOrderDetail,
    isPrivate: routes.preOrderDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderDetail.path,
    component: OrderDetail,
    isPrivate: routes.orderDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.unpaidOrder.path,
    component: UnPaidOrders,
    isPrivate: routes.unpaidOrder.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.parcelDetail.path,
    component: OmParcelDetail,
    isPrivate: routes.parcelDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.parcelOrderCompleteDetail.path,
    component: ParcelOrderCompleteDetail,
    isPrivate: routes.parcelOrderCompleteDetail.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.parcelList.path,
    component: ParcelList,
    isPrivate: routes.parcelList.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderList.path,
    component: OrderList,
    isPrivate: routes.orderList.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.lockerOrderSubmit.path,
    component: ParcelOrder,
    isPrivate: routes.lockerOrderSubmit.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderSubmit.path,
    component: ParcelOrder,
    isPrivate: routes.orderSubmit.isPrivate,
    accessRole: hasAccessLevel(10),
  },
  {
    path: routes.orderSubmitForBranch.path,
    component: BranchParcelOrder,
    isPrivate: routes.orderSubmitForBranch.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
